import React from 'react';

const TransactionNumberSerie: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="mb-6">
          <h1 className="text-3xl font-bold text-gray-900">Transcation Number Series</h1>
          <p className="text-gray-600 mt-2">
              Transaction Number Series is
          </p>
        </div>



        {/* Main Users Image */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <div className="mb-6">
            <img
              src="/images/settings/transactionnumberseries/transactionnumberserie.png"
              alt="Transaction Number Series Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Add Custom Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Add Custom Transcation Number Series</h2>
          <p className="text-gray-600 mb-4">
            Transaction Number Series is
          </p>
          <p className="text-gray-600 mb-4">
            To add a custom Transaction Number Series:
          </p>
          <ol className="list-decimal list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings</li>
            <li>Select Transcation Number Series</li>
            <li>Click the New Transcation Number Series button in the top right corner of the page.</li>
            <li>Fill the need information about Transaction.</li>
            <li>Click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/transactionnumberseries/transactionnumberserie-new.png"
              alt="Add Custom Transaction Number Series Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>

        {/* Edit Role Section */}
        <div className="bg-white rounded-lg shadow-sm border border-gray-200 p-6 mb-6">
          <h2 className="text-xl font-semibold text-gray-900 mb-4">Edit Transaction Number Series</h2>
          <p className="text-gray-600 mb-4">
          After you have added a new Transaction Number Series, you can edit their data if required. Here’s how:
          </p>
          <ol className="list-disc list-inside text-gray-600 space-y-2 mb-4">
            <li>Go to Settings </li>
            <li>Select the Transaction Number you want to edit and click down arrow button</li>
            <li>Click Edit.</li>
            <li>Make the required changes and click Save.</li>
          </ol>
          <div className="mb-6">
            <img
              src="/images/settings/transactionnumberseries/transactionnumberserie-edit.png"
              alt="Add Custom Transaction Number Series Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
          <div className="mb-6  mt-6">
            <img
              src="/images/settings/transactionnumberseries/transactionnumberserie-edit-1.png"
              alt="Transaction Number Series Settings Page"
              className="w-full max-w-4xl h-auto border border-gray-200 rounded-lg shadow-sm"
            />
          </div>
        </div>



      </div>

    </div>
  );
};

export default TransactionNumberSerie;
